export const HOME = {
  FC: 'free-cash',
  NP: 'no-prize',
  NONE: 'none'
} as const;

export type HomeState = typeof HOME[keyof typeof HOME];